/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  SuggestExclusionRequestBody,
  SuggestExclusionRequestBody$Outbound,
  SuggestExclusionRequestBody$outboundSchema,
} from "../components/suggestexclusionrequestbody.js";

export type SuggestExclusionSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type SuggestExclusionSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type SuggestExclusionSecurity = {
  option1?: SuggestExclusionSecurityOption1 | undefined;
  option2?: SuggestExclusionSecurityOption2 | undefined;
};

export type SuggestExclusionRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  suggestExclusionRequestBody: SuggestExclusionRequestBody;
};

/** @internal */
export type SuggestExclusionSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const SuggestExclusionSecurityOption1$outboundSchema: z.ZodMiniType<
  SuggestExclusionSecurityOption1$Outbound,
  SuggestExclusionSecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function suggestExclusionSecurityOption1ToJSON(
  suggestExclusionSecurityOption1: SuggestExclusionSecurityOption1,
): string {
  return JSON.stringify(
    SuggestExclusionSecurityOption1$outboundSchema.parse(
      suggestExclusionSecurityOption1,
    ),
  );
}

/** @internal */
export type SuggestExclusionSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const SuggestExclusionSecurityOption2$outboundSchema: z.ZodMiniType<
  SuggestExclusionSecurityOption2$Outbound,
  SuggestExclusionSecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function suggestExclusionSecurityOption2ToJSON(
  suggestExclusionSecurityOption2: SuggestExclusionSecurityOption2,
): string {
  return JSON.stringify(
    SuggestExclusionSecurityOption2$outboundSchema.parse(
      suggestExclusionSecurityOption2,
    ),
  );
}

/** @internal */
export type SuggestExclusionSecurity$Outbound = {
  Option1?: SuggestExclusionSecurityOption1$Outbound | undefined;
  Option2?: SuggestExclusionSecurityOption2$Outbound | undefined;
};

/** @internal */
export const SuggestExclusionSecurity$outboundSchema: z.ZodMiniType<
  SuggestExclusionSecurity$Outbound,
  SuggestExclusionSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => SuggestExclusionSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => SuggestExclusionSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function suggestExclusionSecurityToJSON(
  suggestExclusionSecurity: SuggestExclusionSecurity,
): string {
  return JSON.stringify(
    SuggestExclusionSecurity$outboundSchema.parse(suggestExclusionSecurity),
  );
}

/** @internal */
export type SuggestExclusionRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  SuggestExclusionRequestBody: SuggestExclusionRequestBody$Outbound;
};

/** @internal */
export const SuggestExclusionRequest$outboundSchema: z.ZodMiniType<
  SuggestExclusionRequest$Outbound,
  SuggestExclusionRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    suggestExclusionRequestBody: SuggestExclusionRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      suggestExclusionRequestBody: "SuggestExclusionRequestBody",
    });
  }),
);

export function suggestExclusionRequestToJSON(
  suggestExclusionRequest: SuggestExclusionRequest,
): string {
  return JSON.stringify(
    SuggestExclusionRequest$outboundSchema.parse(suggestExclusionRequest),
  );
}
